module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "switches columns"
  }, _vm._l((_vm.switches), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "switch-item column",
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.switchItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "wrapper",
      class: {
        'active': _vm.currentIndex === index
      }
    }, [(!_vm.isMobile) ? _c('img', {
      attrs: {
        "src": _vm.currentIndex === index ? item.colorImg : item.img
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "uptitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), (_vm.isMobile) ? _c('span', {
      staticClass: "line",
      class: {
        'active': _vm.currentIndex === index
      }
    }) : _vm._e()])])])
  })), _vm._v(" "), _vm._l((_vm.para), function(item, index) {
    return _c('p', {
      key: index,
      class: {
        'active': _vm.currentIndex === index
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f017c7ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/switches/switches.vue
// module id = 468
// module chunks = 1